// extracted by mini-css-extract-plugin
export default {"subDialogContainer":"subDialogContainer--kMpcn","header":"header--gETpg","showDialogHerader":"showDialogHerader--xpIK1"};